import React from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";

// mui
import { grey } from "@mui/material/colors";

const style = {
  text: css`
    color: ${grey[500]};
    font-size: 0.8rem;
  `,
};

type SenderProps = {
  sender: CometChat.User;
};

const Sender: React.FC<SenderProps> = (props) => {
  const { sender } = props;

  return <div css={style.text}>{sender.getName()}</div>;
};

export default Sender;
